import { Routes } from '@angular/router';
import { authGuard } from '@coin/shared/auth/feature';
import { FrontendType } from '@coin/shared/core/util-enums';
import { OrgChartsSocCompatibilityComponent } from './components/org-charts-compatibility.component';

export const SOC_ROUTING_COMPATIBILITY_ROUTES: Routes = [
  {
    path: 'orgcharts/orgchart',
    canActivate: [authGuard],
    data: {
      frontendType: FrontendType.cosmos
    },
    component: OrgChartsSocCompatibilityComponent
  }
];
